function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 28 28",
  fill: "none"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.84 2.47H2.47v22.37h22.37V2.47zM0 0v27.31h27.31V0H0z",
  fill: "#354147"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.994 8.413L17.302 16.9l-6.83-1.26-3.548 4.703-1.97-1.488 4.466-5.92 6.734 1.24 4.79-7.138 2.05 1.376z",
  fill: "#354147"
})));